var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 6.71429H1M10.9 11.2857H5.4M1 4.65714L1 13.3429C1 14.623 1 15.263 1.23979 15.752C1.45071 16.1821 1.78726 16.5317 2.20122 16.7509C2.67183 17 3.28788 17 4.52 17L19.48 17C20.7121 17 21.3282 17 21.7988 16.7509C22.2127 16.5317 22.5493 16.1821 22.7602 15.752C23 15.263 23 14.623 23 13.3429V4.65714C23 3.37702 23 2.73696 22.7602 2.24802C22.5493 1.81794 22.2127 1.46827 21.7988 1.24913C21.3282 1 20.7121 1 19.48 1L4.52 1C3.28789 1 2.67183 1 2.20122 1.24913C1.78726 1.46827 1.45071 1.81794 1.23979 2.24802C1 2.73696 1 3.37702 1 4.65714Z",
    stroke: "#26EB06",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.2545c0ca54dcc1e4825a117d530ca4c8.svg";
export { ForwardRef as ReactComponent };